import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachDealersToGroup } from '@/features/security-admin/services/security-groups';

export function useAttachDealerToGroupMutation(dealerId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (groupId: string) => attachDealersToGroup(groupId, { dealer_ids: [dealerId] }),
    onSuccess: (_data, groupId) => {
      queryClient.invalidateQueries({ queryKey: ['security', 'dealers', dealerId, 'groups'] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
    },
  });
}
